const rules = {
	user: {
		static: [],
	},

	admin: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
		],
	},
};

export default rules;

// Permission-to-UI-action mapping
// Maps frontend UI action strings to backend permission names
const actionToPermissions = {
	"drawer-admin-items:view": [
		"users:view",
		"queues:view",
		"queues:create",
		"queues:edit",
		"settings:view",
		"settings:edit",
		"roles:view",
		"auditLogs:view",
	],
	"user-modal:editProfile": ["users:create", "users:edit", "users:delete"],
	"user-modal:editQueues": ["users:create", "users:edit"],
	"tickets-manager:showall": ["tickets:viewAll"],
	"ticket-options:deleteTicket": ["tickets:delete"],
	"ticket-options:transferWhatsapp": ["tickets:transfer"],
	"contacts-page:deleteContact": ["contacts:delete"],
	// Appointments map to themselves. Registering them here (instead of relying
	// only on the literal name match) keeps them working the same way as every
	// other gated action and documents the resource in one place.
	"appointments:view": ["appointments:view"],
	"appointments:create": ["appointments:create"],
	"appointments:edit": ["appointments:edit"],
	"appointments:delete": ["appointments:delete"],
	"appointments:viewAll": ["appointments:viewAll"],
	"appointments:reasons": ["appointments:reasons"],
	"appointments:availability": ["appointments:availability"],
	"billing:view": ["billing:view"],
	"billing:pay": ["billing:pay"],
};

// Check if a user with the given permissions can perform an action
export const checkPermission = (permissions, action) => {
	if (!permissions || !Array.isArray(permissions)) return false;

	// Admin with wildcard has all permissions
	if (permissions.includes("*")) return true;

	// Check direct permission match
	if (permissions.includes(action)) return true;

	// Check mapped permissions
	const requiredPermissions = actionToPermissions[action];
	if (requiredPermissions && requiredPermissions.some(perm => permissions.includes(perm))) {
		return true;
	}

	return false;
};
